import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form';
import { ControlledRadioGroup, ControlledTextField } from '../../../../shared/components';
import PocDirectorySelect from './PocDirectorySelect';

export default function ClientContactSection({ headerActions }) {
  const { watch } = useFormContext();

  const workOrderRequired = watch('client.workOrderRequired');

  return (
    <div className='column'>
      <div className='row gap-5'>
        <Typography variant='body1' fontWeight={500} sx={{ whiteSpace: 'nowrap' }}>
          4. Client Details
        </Typography>
        {headerActions}
      </div>

      <PocDirectorySelect type='client' path='client' />

      <div className='grid grid--2-cols grid--with-divider'>
        <div className='column'>
          <ControlledTextField
            id='client.name'
            name='client.name'
            label='Full name'
            placeholder='Enter full name'
            rules={{
              minLength: { value: 3, message: 'Name must be at least 3 characters' },
              maxLength: { value: 100, message: 'Name cannot exceed 100 characters' },
            }}
          />
          <ControlledTextField
            id='client.mobile'
            name='client.mobile'
            label='Mobile number'
            placeholder='Enter mobile number'
            inputMode='numeric'
            rules={{
              minLength: { value: 10, message: 'Mobile number must be 10 digits' },
              maxLength: { value: 10, message: 'Mobile number must be 10 digits' },
            }}
          />
          <ControlledTextField
            id='client.email'
            name='client.email'
            label='Email address'
            placeholder='Enter email ID'
            type='email'
            rules={{
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: 'Please enter a valid email address',
              },
            }}
          />
          <ControlledTextField
            id='client.companyName'
            name='client.companyName'
            label='Company name'
            placeholder='Enter company name'
            rules={{
              minLength: { value: 3, message: 'Company name must be at least 3 characters' },
              maxLength: { value: 100, message: 'Company name cannot exceed 100 characters' },
            }}
          />

          <ControlledRadioGroup
            name='client.workOrderRequired'
            label='Work Order'
            wrapperOrientation='column'
            orientation='row'
            options={[
              { label: 'Not Required', value: false },
              { label: 'Required', value: true },
            ]}
          />
        </div>

        <div className='column'>
          <ControlledTextField
            id='client.phone'
            name='client.phone'
            label='Phone number'
            placeholder='Enter phone number'
            inputMode='numeric'
            rules={{
              minLength: { value: 10, message: 'Phone number must be 10 digits' },
              maxLength: { value: 10, message: 'Phone number must be 10 digits' },
            }}
          />

          <ControlledTextField
            id='client.whatsapp'
            name='client.whatsapp'
            label='WhatsApp number'
            placeholder='Enter WhatsApp number'
            inputMode='numeric'
            rules={{
              minLength: { value: 10, message: 'WhatsApp number must be 10 digits' },
              maxLength: { value: 10, message: 'WhatsApp number must be 10 digits' },
            }}
          />

          <ControlledTextField
            id='client.officeAddress'
            name='client.officeAddress'
            label='Office address'
            placeholder='Enter office address'
            isMultiline
            // rows={2}
            rules={{
              minLength: { value: 3, message: 'Address must be at least 3 characters' },
              maxLength: { value: 300, message: 'Address cannot exceed 300 characters' },
            }}
          />

          <ControlledTextField
            name='client.gstNumber'
            placeholder='GST number'
            label='GST number'
          />

          <ControlledTextField
            name='client.workOrderNumber'
            label='Work order number'
            placeholder='Enter work order number'
            disabled={!workOrderRequired}
            rules={{
              validate: (value, formValues) =>
                !formValues.client.workOrderRequired ||
                Boolean(value?.trim()) ||
                'Work order number is required',
            }}
          />
        </div>
      </div>
    </div>
  );
}
